<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-row>
          <b-col md="6" class="my-1">
            <b-navbar-nav>
              <b-button @click="goBack" size="sm" variant="outline-secondary">
                <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
              </b-button>
            </b-navbar-nav>
            <h5 class="mt-1 mr-2">
              {{ $route.name }}
            </h5>
          </b-col>
          <b-col md="2">
            <h5>
              <small v-if="isLoading == false">{{ totalData }} Entries</small>
            </h5>
          </b-col>
          <b-col md="4">
            <b-button
              class="pull-right ml-1 mt-1"
              :variant="
                Filter.ContainerNoFilter ||
                Filter.JobNoFilter ||
                Filter.EnqNoFilter ||
                Filter.commonFilter ||
                Filter.contTypeFilter ||
                Filter.clientFilter ||
                Filter.clientIDFilter ||
                Filter.createdByFilter ||
                Filter.PODIDFilter ||
                Filter.TerritoryFilter ||
                Filter.branchFilter ||
                Filter.slineIDFilter ||
                Filter.FPODFilter ||
                Filter.statusFilter ||
                Filter.billStatusFilter ||
                Filter.dateRange.startDate ||
                Filter.dateRange.endDate
                  ? 'outline-danger'
                  : 'outline-primary'
              "
              :class="' ml-4' + visible ? null : 'collapsed'"
              :aria-expanded="visible ? 'true' : 'false'"
              aria-controls="collapse-4"
              @click="visible = !visible"
              style="font-size: 0.675rem"
              >{{
                Filter.ContainerNoFilter ||
                Filter.JobNoFilter ||
                Filter.EnqNoFilter ||
                Filter.commonFilter ||
                Filter.contTypeFilter ||
                Filter.clientFilter ||
                Filter.clientIDFilter ||
                Filter.createdByFilter ||
                Filter.PODIDFilter ||
                Filter.TerritoryFilter ||
                Filter.branchFilter ||
                Filter.slineIDFilter ||
                Filter.FPODFilter ||
                Filter.statusFilter ||
                Filter.billStatusFilter ||
                Filter.dateRange.startDate ||
                Filter.dateRange.endDate
                  ? "Filter ON"
                  : "Filter OFF"
              }}</b-button
            >
            <b-button
              class="pull-right ml-1 mt-1"
              v-if="getRolloverContList.length > 0"
              :disabled="ExcelBtnName != 'Export As Excel' ? true : false"
              @click="getReports('getRolloverContList', 'Export As Excel')"
              size="sm"
              variant="warning"
              style="font-size: 0.675rem"
            >
              {{ ExcelBtnName }}
              <b-spinner
                v-if="ExcelBtnName != 'Export As Excel'"
                small
                label="Small Spinner"
              ></b-spinner
            ></b-button>
          </b-col>

          <b-col cols="12">
            <div>
              <b-pagination
                limit="25"
                align="center"
                v-model="pagination.currentPage"
                :per-page="pagination.perPage"
                :total-rows="totalData"
                @change="onPageChange($event)"
              ></b-pagination>
            </div>
          </b-col>
        </b-row>
        <div v-if="visible">
          <b-card>
            <b-collapse v-model="visible" id="collapse-2">
              <b-row>
                <b-col md="3">
                  <label>Status</label>

                  <model-list-select
                    :list="StatusList"
                    v-model="Filter.statusFilter"
                    option-value="DVal"
                    option-text="DText"
                    placeholder="Select"
                    @input="getRolloverContTempList('Normal', '0', '0', '1', '1')"
                  ></model-list-select>
                </b-col>
                <b-col md="3">
                  <label>Billing Status</label>

                  <model-list-select
                    :list="BillingStatusList"
                    v-model="Filter.billStatusFilter"
                    option-value="DVal"
                    option-text="DText"
                    placeholder="Select"
                    @input="getRolloverContTempList('Normal', '0', '0', '1', '1')"
                  ></model-list-select>
                </b-col>
                <b-col md="3">
                  <label>Date</label>
                  <date-range-picker
                    :always-show-calendars="showCal"
                    v-model="Filter.dateRange"
                    :startDate="startDate"
                    :endDate="endDate"
                    :locale-data="locale"
                    :disabled="Filter.DFlag ? true : false"
                    @update="getRolloverContTempList('Normal', '0', '0', '1', '1')"
                  ></date-range-picker>
                </b-col>

                <b-col md="3">
                  <label>Client</label>
                  <b-form-input
                    type="text"
                    :formatter="capitalizeAll"
                    placeholder="Search Client Name Filter"
                    id="clientFilter"
                    name="clientFilter"
                    autocomplete="off"
                    v-model="Filter.clientFilter"
                    @input="getRolloverContTempList('Normal', '0', '0', '1', '1')"
                  ></b-form-input>
                </b-col>

                <b-col md="3">
                  <label>Job No Filter</label>
                  <b-form-input
                    type="text"
                    :formatter="capitalizeAll"
                    placeholder="Search Job No Filter"
                    id="JobNoFilter"
                    name="JobNoFilter"
                    autocomplete="off"
                    v-model="Filter.JobNoFilter"
                    @input="getRolloverContTempList('Normal', '0', '0', '1', '1')"
                  ></b-form-input>
                </b-col>
                <b-col md="3">
                  <label>Container No Filter</label>
                  <b-form-input
                    type="text"
                    :formatter="capitalizeAll"
                    placeholder="Search Container No Filter"
                    id="ContainerNoFilter"
                    name="ContainerNoFilter"
                    autocomplete="off"
                    v-model="Filter.ContainerNoFilter"
                    @input="getRolloverContTempList('Normal', '0', '0', '1', '1')"
                  ></b-form-input>
                </b-col>
                <b-col md="3">
                  <label>Enq No Filter</label>
                  <b-form-input
                    type="text"
                    :formatter="capitalizeAll"
                    placeholder="Search Enq No Filter"
                    id="EnqNoFilter"
                    name="EnqNoFilter"
                    autocomplete="off"
                    v-model="Filter.EnqNoFilter"
                    @input="getRolloverContTempList('Normal', '0', '0', '1', '1')"
                  ></b-form-input>
                </b-col>
                <b-col md="3">
                  <label>Common Filter</label>
                  <b-form-input
                    type="text"
                    :formatter="capitalizeAll"
                    placeholder="Search Common Filter"
                    id="commonFilter"
                    name="commonFilter"
                    autocomplete="off"
                    v-model="Filter.commonFilter"
                    @input="getRolloverContTempList('Normal', '0', '0', '1', '1')"
                  ></b-form-input>
                </b-col>
                <b-col md="3">
                  <label>
                    <b> Container Type </b>
                  </label>
                  <model-list-select
                    :list="$store.getters['common/getAllContainerTypeList']"
                    option-value="containerTypeId"
                    option-text="containerType"
                    id="contTypeFilter"
                    @input="getRolloverContTempList('Normal', '0', '0', '1', '1')"
                    v-model="Filter.contTypeFilter"
                    placeholder="Select Container Type"
                  ></model-list-select>
                </b-col>
                <b-col md="3">
                  <label>Territory</label>
                  <model-list-select
                    :list="$store.getters['commonDropdownMaster/getAllENQTERIOTRYDDList']"
                    v-model="Filter.TerritoryFilter"
                    option-value="text"
                    option-text="text"
                    placeholder="Select Territory"
                    @input="
                      getPODLIST(Filter.TerritoryFilter);
                      getRolloverContTempList('Normal', '0', '0', '1', '1');
                    "
                  ></model-list-select>
                </b-col>
                <b-col md="3">
                  <label>POD</label>
                  <model-list-select
                    @input="
                      getLocationList(
                        $event,
                        'Sea_Port_NonIndia',
                        'getPortDischargeList'
                      );
                      getRolloverContTempList('Normal', '0', '0', '1', '1');
                    "
                    @searchchange="
                      getLocationList($event, 'Sea_Port_NonIndia', 'getPortDischargeList')
                    "
                    :list="
                      getPortDischargeList.length > 0
                        ? getPortDischargeList
                        : $store.getters['common/getAllPODList']
                    "
                    v-model="Filter.PODIDFilter"
                    option-value="pickupId"
                    option-text="pickupLocation"
                    placeholder="Select POD"
                  ></model-list-select>
                </b-col>
                <b-col md="3">
                  <label>FPOD</label>
                  <model-list-select
                    @input="
                      getLocationList($event, 'All', 'finalAllPlaceDataPOD');
                      getRolloverContTempList('Normal', '0', '0', '1', '1');
                    "
                    @searchchange="getLocationList($event, 'All', 'finalAllPlaceDataPOD')"
                    :list="$store.getters['common/getAllLocationDetailsFinalList']"
                    v-model="Filter.FPODFilter"
                    option-value="pickupId"
                    option-text="pickupLocation"
                    placeholder="Select Final Port of Discharge"
                  ></model-list-select>
                </b-col>
                <b-col md="3">
                  <label>Shipping Line</label>
                  <model-list-select
                    :list="$store.getters['common/getAllShippingLineList']"
                    v-model="Filter.slineIDFilter"
                    option-value="shippingId"
                    option-text="shippingLine"
                    placeholder="Select Shipping Line"
                    :isDisabled="
                      $sessionsStorage.get('designation') != 'Admin' ? true : false
                    "
                    @input="getRolloverContTempList('Normal', '0', '0', '1', '1')"
                  ></model-list-select>
                </b-col>
                <b-col md="3">
                  <label>Branch</label>
                  <model-list-select
                    :list="$store.getters['common/getAllBranchList']"
                    id="branchfilter"
                    v-model="Filter.branchFilter"
                    option-value="pickupId"
                    option-text="pickupLocation"
                    placeholder="All"
                    :isDisabled="
                      $sessionsStorage.get('designation') != 'Admin' ? true : false
                    "
                    @input="getRolloverContTempList('Normal', '0', '0', '1', '1')"
                  ></model-list-select>
                </b-col>
                <b-col md="3">
                  <label>
                    <b> Client Name </b>
                  </label>
                  <model-list-select
                    :list="$store.getters['common/getAllClientList']"
                    id="clientIDFilter"
                    @input="getRolloverContTempList('Normal', '0', '0', '1', '1')"
                    v-model="Filter.clientIDFilter"
                    option-value="clientId"
                    option-text="clientName"
                    placeholder="Select Client Name"
                  ></model-list-select>
                </b-col>
                <b-col md="3">
                  <label>
                    <b> Created User </b>
                  </label>
                  <model-list-select
                    :list="$store.getters['common/getAllUserList']"
                    id="createdByFilter"
                    @input="getRolloverContTempList('Normal', '0', '0', '1', '1')"
                    v-model="Filter.createdByFilter"
                    option-value="userId"
                    option-text="employeeName"
                    placeholder="Select Created User"
                  ></model-list-select>
                </b-col>
                <b-col md="12" class="mt-2">
                  <b-button
                    size="sm"
                    style="margin-left: auto"
                    class="ml-1 pull-right"
                    @click="clearFilter"
                    variant="outline-danger"
                    >Reset</b-button
                  >
                </b-col>
              </b-row>
            </b-collapse>
          </b-card>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="table-responsive tableMain gutr">
              <b-table
                show-empty
                stacked="md"
                responsive
                :items="getRolloverContList"
                :fields="ContainerFields"
                primary-key="id_email_section"
                :per-page="pagination.perPage"
                :filter="filter"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :sort-direction="sortDirection"
                @filtered="onFiltered"
                class="position-relative"
              >
                <template slot="SN" slot-scope="row0">
                  <span>{{
                    row0.index + 1 + (pagination.currentPage - 1) * pagination.perPage
                  }}</span>
                </template>

                <template slot="containerNo" slot-scope="row1">
                  <span  @click="getShipmentSubscription(row1.item)" style="color: blue;font-weight:bold">Container No : <u>{{ row1.item.containerNo }}</u></span
                  ><br />
                  <span
                    :style="
                      row1.item.subscription_id ? 'color: blue;font-weight:bold' : ''
                    "
                    @click="
                      row1.item.subscription_id ? goToSubscriptionPage(row1.item) : ''
                    "
                    >Booking No : <u>{{ row1.item.booking_number }}</u></span
                  ><br />
                 
                  <span
                    :style="
                      row1.item.subscription_id ? 'color: blue;font-weight:bold' : ''
                    "
                    @click="row1.item.allModuleId ? goExportFCLPage(row1.item) : ''"
                    >Job No : <u>{{ row1.item.JobNo }}</u></span
                  ><br />
                  <span>Job Type : {{ row1.item.JobType }}</span
                  ><br />
                  <span>Job Date : {{ row1.item.JobDate }}</span
                  ><br />
                  <b-button
                    v-if="$sessionsStorage.get('is_Mobile') != 'port'"
                    size="sm"
                    class="mt-2"
                    style="font-size: 0.675rem"
                    @click="showDocModal(row1.item)"
                    variant="outline-info"
                    >Summary & Documents</b-button
                  >
                  <Assignment-Summary
                    v-if="$sessionsStorage.get('is_Mobile') != 'port'"
                    :title="'Shipment Summary Tracking - '"
                    :assign_date="row1.item.JobDate"
                    :assign_job_type="row1.item.JobType"
                    :assign_raised_from="'Raised From: '"
                    :assign_raised_by="'Raised By: ' + row1.item.raisedBy"
                    :fk_all_module_id="row1.item.allModuleId"
                    :jb_series="row1.item.JobNo"
                    :fk_client_id="''"
                    :fk_pod_id="''"
                  />
                  <InvExpSummary
                    v-if="row1.item.allModuleId"
                    :PMC_title="'Inv Exp Summary Job No - ' + row1.item.JobNo"
                    :PMC_JOBID="row1.item.allModuleId"
                    :PMC_JOBNO="row1.item.JobNo"
                    :PMC_JOBDATE="row1.item.JobDate"
                    :PMC_JOBTYPE="row1.item.JobType"
                    :PMC_AgentType="''"
                    :PMC_Client="row1.item.clientName"
                    :PMC_Sline="row1.item.shippingLine"
                  />
                  <!-- <JobWisePaymentsDetails
                  v-if="row1.item.allModuleId"
                  :allModuleId="Number(row1.item.allModuleId)"
                  :JobNo="row1.item.JobNo"
                  /> -->
                  <ContainerSummary
                    v-if="row1.item.allModuleId"
                    :PMC_title="'Container Summary Job No - ' + row1.item.JobNo"
                    :PMC_JOBID="row1.item.allModuleId"
                    :PMC_JOBNO="row1.item.JobNo"
                    :PMC_JOBDATE="row1.item.JobDate"
                    :PMC_JOBTYPE="row1.item.JobType"
                    :PMC_AgentType="''"
                    :PMC_Client="row1.item.clientName"
                    :PMC_Sline="row1.item.shippingLine"
                  />
                </template>
                <template slot="GRNSeries" slot-scope="row2">
                  <span>GRN No : {{ row2.item.GRNSeries }}</span
                  ><br />
                  <span>GRN Date : {{ row2.item.GRNDATE }}</span
                  ><br />
                  <span><b>Client : {{ row2.item.clientName }}</b></span
                  ><br />
                  <span><b>Sline : {{ row2.item.shippingLine }}</b></span
                  ><br />
                  <span>POR : {{ row2.item.POR }}</span
                  ><br />
                  <span>POL : {{ row2.item.POL }}</span
                  ><br />
                  <span>POD : {{ row2.item.POD }}</span
                  ><br />
                  <span>FPOD : {{ row2.item.FPOD }}</span>
                </template>
                <template slot="INVNO" slot-scope="row2">
                  <span>Inv No : {{ row2.item.INVNO }}</span
                  ><br />
                  <span>Inv Date : {{ row2.item.INVDATE }}</span
                  ><br />
                  <span>BOE No : {{ row2.item.BOENO }}</span
                  ><br />
                  <span>BOE Date : {{ row2.item.BOEDATE }}</span
                  ><br />
                  <span>Line Seal : {{ row2.item.LineSealNo }}</span
                  ><br />
                  <span>Custom Seal : {{ row2.item.customSealNo }}</span
                  ><br />
                </template>

                <template slot="netWeight" slot-scope="row2">
                  <span>Net Weight : {{ row2.item.netWeight }}</span
                  ><br />
                  <span>Gross Weight : {{ row2.item.grossWeight }}</span
                  ><br />
                  <span>Tare Weight : {{ row2.item.tareWeight }}</span
                  ><br />
                  <span>Unit : {{ row2.item.weightUnit }}</span
                  ><br />
                  <span>Measurement : {{ row2.item.measurement }}</span
                  ><br />
                  <span>Package : {{ row2.item.packageName }}</span
                  ><br />
                  <span>No.of Package : {{ row2.item.noOfpkgUnit }}</span
                  ><br />
                </template>

                <template slot="raisedBy" slot-scope="row3">
                  <span v-if="row3.item.raisedBy"
                    >Raised By : {{ row3.item.raisedBy }}<br
                  /></span>
                  <span v-if="row3.item.create_date"
                    >Created Date : {{ row3.item.create_date }}<br
                  /></span>
                  <span v-if="row3.item.updatedBy"
                    >Updated By : {{ row3.item.updatedBy }}<br
                  /></span>
                  <span v-if="row3.item.update_date"
                    >Updated Date : {{ row3.item.update_date }}<br
                  /></span>
                </template>
              </b-table>
            </div>
            <div>
              <b-pagination
                limit="25"
                align="center"
                v-model="pagination.currentPage"
                :per-page="pagination.perPage"
                :total-rows="totalData"
                @change="onPageChange($event)"
              ></b-pagination>
            </div>
          </div>
        </div>

        <b-modal
          class="modal-dialog-doc"
          size="xl"
          no-close-on-esc
          no-close-on-backdrop
          ref="doc-modal"
          hide-footer
          :title="'Assignment Summary & Documents - ' + JOBSERIES"
        >
          <div v-if="ALLMODULE">
            <doc-form :allModuleIdProp="ALLMODULE" :JOBSERIES="JOBSERIES" />
          </div>
          <b-button class="mt-3" variant="outline-danger" block @click="hideDocModal"
            >Close
          </b-button>
        </b-modal>
      </b-card-text>
    </b-card>
    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop"
    ></md-dialog-alert>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import CustomLoader from "../common/customLoader.vue";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import {
  lastVisitPage,
  globalPermissionStatus,
  GlobalGetLocation,
} from "../../helper/collection";
import DateRangePicker from "vue2-daterange-picker";
import CommonService from "../../services/CommonService.js";
import { ModelListSelect, MultiSelect } from "vue-search-select";
import Multiselect from "vue-multiselect";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant";
import InvExpSummary from "../common/moduleBasedInvExpSummary.vue";
import ContainerSummary from "../common/moduleBasedContaierSummary.vue";
import JobWisePaymentsDetails from "../common/jobWisePaymentsDetails.vue";
import AssignmentSummary from "../common/assignmentSummary.vue";
import DocForm from "../allModuleForm/docLibrary.vue";
export default {
  // Component logic for Tab 1
  beforeMount() {
    lastVisitPage(this.$router.history.current.fullPath);
    this.$store.dispatch(
      "common/setAllPODList",
      JSON.stringify({
        itemCode: "PODList",
        type: "Territory",
        Territory: "",
      })
    );
    this.$store.dispatch(
      "common/setAllLocationDetailsFinalList",
      JSON.stringify({
        itemCode: "LocationDetailsFinalList",
      })
    );
    this.$store.dispatch(
      "common/setAllContainerTypeList",
      JSON.stringify({
        itemCode: "ContainerTypeList",
      })
    );
    this.$store.dispatch(
      "common/setAllUserList",
      JSON.stringify({
        itemCode: "GET_USERLIST_Data",
      })
    );
    this.$store.dispatch(
      "common/setAllClientList",
      JSON.stringify({
        itemCode: "ClientList",
      })
    );
    this.$store.dispatch(
      "common/setAllShippingLineList",
      JSON.stringify({
        itemCode: "ShippingLineList",
      })
    );
    this.$store.dispatch(
      "common/setAllBranchList",
      JSON.stringify({
        filter: "BranchList",
        active: "all",
      })
    );
    this.$store.dispatch(
      "commonDropdownMaster/setAllENQTERIOTRYDDList",
      JSON.stringify({
        itemCode: "getLocationTeratoryDetails",
        type: "Normal",
      })
    );
    this.$store.dispatch("setCurrentRoute", "/ctt/rollover-event");
    if (this.lastVisitPage && this.$sessionsStorage.get("lastVisitPage")) {
      this.fetchLastPage(this.lastVisitPage);
    } else {
      this.getRolloverContTempList("Normal", "0", "0", "1", "1");
    }
  },
  mounted() {},
  mounted() {},
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  beforeDestroy() {},

  destroyed() {},
  data() {
    return {
      getPortDischargeList: [],
      docURL: URL_BASE_DOC,
      selectDateFormat,
      lastVisitPage: this.$sessionsStorage.get("lastVisitPage"),
      ExcelBtnName: "Export As Excel",
      visible: false,
      getRolloverContList: [],
      totalData: 0,
      ALLMODULE: "",
      JOBSERIES: "",
      ContainerFields: [
        {
          key: "SN",
          mainkey: "SN",
          label: "SN.",
          sortable: true,
          sortDirection: "ASC",
          table: "A.",
        },

        {
          key: "containerType",
          mainkey: "containerType",
          label: "Container Type",
          sortable: true,
          sortDirection: "ASC",
          table: "B.",
        },
        {
          key: "containerNo",
          mainkey: "containerNo",
          label: "Container No",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "sub_noti_event_message",
          mainkey: "sub_noti_event_message",
          label: "Event MSG",
          sortable: true,
          sortDirection: "ASC",
          table: "D.",
        },

        {
          key: "INVNO",
          mainkey: "INVNO",
          label: "Shipper Inv",
          sortable: true,
          sortDirection: "ASC",
          table: "F.",
        },

        {
          key: "netWeight",
          mainkey: "netWeight",
          label: "Net Wgt.",
          sortable: true,
          sortDirection: "ASC",
          table: "J.",
        },

        {
          key: "GRNSeries",
          mainkey: "GRNSeries",
          label: "GRN Series",
          sortable: true,
          sortDirection: "ASC",
          table: "Q.",
        },

        {
          key: "raisedBy",
          mainkey: "raisedBy",
          label: "Action",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
      ],
      pagination: {
        currentPage: 1,
        perPage: 25,
        pageOptions: [5, 10, 15],
      },
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      BillingStatusList: [
        {
          DVal: "0",
          DText: "Open",
        },
        {
          DVal: "1",
          DText: "Closed",
        },
        {
          DVal: "All",
          DText: "All",
        },
      ],
      StatusList: [
        {
          DVal: "0",
          DText: "Normal",
        },
        {
          DVal: "4",
          DText: "Rollover warning (vessel change)",
        },
        {
          DVal: "3",
          DText: "Container gate-out at POD",
        },
        {
          DVal: "16",
          DText: "Port changed (rerouting)",
        },
        {
          DVal: "24",
          DText: "ETD at POL postponed (> 2 days)",
        },
        {
          DVal: "3",
          DText: "Vessel approaching POD",
        },
        {
          DVal: "8",
          DText: "ETA at POD postponed (> 2 days)",
        },
        {
          DVal: "30",
          DText: "Customs/Carrier Release",
        },
        {
          DVal: "All",
          DText: "All",
        },
      ],
      Filter: {
        ContainerNoFilter: "",
        JobNoFilter: "",
        EnqNoFilter: "",
        contTypeFilter: "",
        clientIDFilter: "",
        commonFilter: "",
        clientFilter: "",
        createdByFilter: "",
        PODIDFilter: "",
        TerritoryFilter: "",
        branchFilter: "",
        slineIDFilter: "",
        FPODFilter: "",
        statusFilter: "4",
        billStatusFilter: "0",
        dateRange: {
          startDate: "",
          endDate: "",
        },
        startDate: "",
        endDate: "",
      },
      openLeft: "left",
      showCal: false,
      startDate: "2017-09-05",
      endDate: "2017-09-15",
      dateRange: {
        startDate: "",
        endDate: "",
      },
      locale: {
        direction: "ltr",
        format: "mm/dd/yyyy",
        separator: " - ",
        applyLabel: "Apply",
        cancelLabel: "Cancel",
        weekLabel: "W",
        customRangeLabel: "Custom Range",
        daysOfWeek: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        monthNames: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
        firstDay: 0,
      },
      alert: {
        content: "Are you sure you want to delete ..!",
        ok: "ok",
      },
      value1: [new Date(2019, 9, 8), new Date(2019, 9, 19)],
      value2: [],
      langType: {
        pickers: ["Today", "Yesterday", "This Month", "This Year"],
      },
      time: "",
      date: "",
      week: ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"],

      langEnq: {
        pickers: ["", "", "previous 7 days", "previous 30 days"],
      },
      isLoading: false,
    };
  },

  components: {
    CustomLoader,
    DatePicker,
    ModelListSelect,
    DateRangePicker,

    MultiSelect,
    Multiselect,

    DocForm,
    AssignmentSummary,
    InvExpSummary,
    ContainerSummary,
    JobWisePaymentsDetails,
  },
  computed: {},
  watch: {},
  methods: {
    getLocationList(event, type, vmodelArray) {
      let vehicle_drive = {
        value: event,
        type: type,
      };
      let self = this;

      if (event != "") {
        GlobalGetLocation(vehicle_drive, function (error, result) {
          if (error) {
          } else if (result) {
            if (result.length > 0) {
              self[vmodelArray] = result;
              this.getPortDischargeList = result;
            }
          }
        });
        console.log("self[vmodelArray]=>", self);
      }
    },
    getPODLIST(territoryName) {
      this.$store.dispatch(
        "common/setAllPODList",
        JSON.stringify({
          itemCode: "PODList",
          type: "Territory",
          Territory: territoryName,
        })
      );
    },
    getShipmentSubscription(item) {
      this.$router.push({
        path: "/tracking/ocean-insights/shipment/" + item.shipment_id,
      });
    },
    goToSubscriptionPage(item) {
      if (item.subscription_id) {
        this.$router.push({
          path: "/tracking/ocean-insights/subscription/" + item.subscription_id,
        });
      }
    },
    goExportFCLPage(item) {
      if (item.isMiscJob == 0 && item.isConsolidation == 0) {
        let FCLID = item.ffExportFclId;
        if (item.newContainerFlow == "1") {
          this.$sessionsStorage.set("editExportFCLId", FCLID);
          this.$router.push({
            path: "/freightForward/newffExportFcl",
          });
        } else {
          this.$sessionsStorage.set("editExportFCLId", FCLID);
          this.$router.push({
            path: "/freightForward/ffExportFcl",
          });
        }
      } else if (item.isMiscJob == 1 && item.isConsolidation == 0) {
        this.$sessionsStorage.set("editSalesExId", item.allModuleId);
        this.$router.push({
          path: "/mainEnquiry/miscSalesExecutionAll",
        });
      } else if (item.isMiscJob == 0 && item.isConsolidation == 1) {
        let FCLCONID = item.ffExportFclId;
        this.$sessionsStorage.set("editffFclConsoExportId", FCLCONID);
        this.$router.push({
          path: "/ffExportCon/ffExportFclConsolidation",
        });
      }
    },
    clearFilter() {
      this.Filter = {
        ContainerNoFilter: "",
        JobNoFilter: "",
        EnqNoFilter: "",
        commonFilter: "",
        clientIDFilter: "",
        contTypeFilter: "",
        clientFilter: "",
        createdByFilter: "",
        PODIDFilter: "",
        TerritoryFilter: "",
        branchFilter: "",
        slineIDFilter: "",
        FPODFilter: "",
        statusFilter: "4",
        billStatusFilter: "0",
        dateRange: {
          startDate: "",
          endDate: "",
        },
        startDate: "",
        endDate: "",
      };
    },
    getCurrentLastDate() {
      var today = new Date();
      var firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
      var lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);

      var firstDay_dd = String(firstDay.getDate()).padStart(2, "0");
      var firstDay_mm = String(firstDay.getMonth() + 1).padStart(2, "0"); //January is 0!
      var firstDay_yyyy = firstDay.getFullYear();

      var lastDay_dd = String(lastDay.getDate()).padStart(2, "0");
      var lastDay_mm = String(lastDay.getMonth() + 1).padStart(2, "0"); //January is 0!
      var lastDay_yyyy = lastDay.getFullYear();

      firstDay = firstDay_yyyy + "/" + firstDay_mm + "/" + firstDay_dd; //2018-06-01
      lastDay = lastDay_yyyy + "/" + lastDay_mm + "/" + lastDay_dd; //2018-06-01

      var dd = String(today.getDate()).padStart(2, "0");
      var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      var yyyy = today.getFullYear();
      today = yyyy + "/" + mm + "/" + dd; //2018-06-01
      this.startDate = today;
      this.Filter.dateRange = {
        startDate: firstDay,
        endDate: lastDay,
      };
      this.getPortDischargeList =
        this.$store.getters["common/getAllPODList"].length > 0
          ? this.$store.getters["common/getAllPODList"]
          : [];
    },

    getRolloverContTempList(type, filterIdD, CURRENT, SEARCH, pageNumber) {
      this.getRolloverContList = [];
      let payload = {};
      if (type == "Normal") {
        this.isLoading = true;
      }
      payload = {
        itemCode: "getJobContainerDetails",
        type: type,
        DCfilterId: filterIdD,
        searchVal: this.filter,
        DCfilterId: filterIdD,
        fromSearch: SEARCH,
        currentPage: CURRENT,
        perPage: this.pagination.perPage,
        Filter: this.Filter,
      };

      CommonService.getAllJobList(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          this.isLoading = false;
          if (status == 200 && data) {
            if (type == "Excell") {
              if (data.ContainerList.length > 0) {
                this.totalData = data.totalRows;
                this.getRolloverContList = data.ContainerList;
              }
              this.ExcelBtnName = "Export As Excel";
              window.location.href =
                `https://uploadsp.pridel.com/Pridel_Reports/` + data.excelName;
            } else {
              if (data.ContainerList.length > 0) {
                this.totalData = data.totalRows;
                this.getRolloverContList = data.ContainerList;
              }
            }
          }
          this.isLoading = false;
        })
        .catch((error) => {
          console.log("Catch on getRolloverContList Error: ", error);
        });
    },
    onFiltered(filtered) {
      this.totalRows = filtered.length;
      this.pagination.currentPage = 1;
    },
    clearTimeout() {},
    goBack() {
      window.history.go(-1);
    },

    debounceSearch(event) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.getRolloverContTempList("Normal", "0", "0", "1", "1");
      }, 1000);
    },
    getReports(id, btnName) {
      this.isLoading = true;
      this.ExcelBtnName = "Downloading Please Wait .....";
      this.getRolloverContTempList("Excell", "0", "0", "1", "1");
    },
    fetchLastPage(event) {
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = parseInt(event) * this.pagination.perPage - this.pagination.perPage;
      }
      this.getRolloverContTempList("Normal", "0", CURRENT, "2", event);
    },
    onPageChange: function (event) {
      this.$sessionsStorage.set("lastVisitPage", event);
      this.$sessionsStorage.set("oldRoute", this.$router.history.current.fullPath);
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = event * this.pagination.perPage - this.pagination.perPage;
      }
      this.getRolloverContTempList("Normal", "0", CURRENT, "2", event);
    },
    showDocModal(item) {
      this.ALLMODULE = "";
      this.JOBSERIES = "";
      this.ALLMODULE = item.allModuleId;
      this.JOBSERIES = item.JobNo;
      console.log(this.ALLMODULE);
      this.$refs["doc-modal"].show();
    },
    hideDocModal() {
      this.$refs["doc-modal"].hide();
    },
  },
};
</script>



// WEBPACK FOOTER //
// RolloverList.vue?0e782ff6